import React, { useState, useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { useStyles, MenuProps } from "./utils";

export const MultiSelectWithCheckBox = props => {
  const classes = useStyles();

  const { options, closeSelect, listOfSelectedLocations } = props;

  const valueObj = options.map(option => option.value);

  const [selected, setSelected] = useState([...listOfSelectedLocations]);

  useEffect(()=>{
    setSelected([...listOfSelectedLocations]);
  },[options]);

  const isAllSelected = valueObj.length > 0 && selected.length === valueObj.length;

  const handleChange = event => {
    const value = event.target.value;
    if (value[value.length - 1] === 'all') {
      setSelected(selected.length === valueObj.length ? [] : valueObj);
      return;
    }
    setSelected(value);
  };

  const selectClosed = () => {
    closeSelect(selected);
  };

  const menuItemsByID = options.reduce((itemsByID, menuItem) => {
    itemsByID[menuItem.value] = menuItem; // eslint-disable-line no-param-reassign
    return itemsByID;
  }, {});

  return (
    <FormControl className={classes.formControl}>
      <Select
        className={classes.selectControl}
        labelId='mutiple-select-label'
        multiple
        value={selected || 'All Locations'}
        onChange={handleChange}
        placeholder={'All Locations'}
        displayEmpty={true}
        renderValue={selected =>
          selected.length === 0?'Select a location':
          selected.length === (valueObj && valueObj.length) && valueObj.length > 1
            ? 'All Locations'
            : selected.length >= 2 && selected.length < (valueObj && valueObj.length)
            ? 'Multiple Locations'
            : selected.map(value => {
                const p = menuItemsByID[value];
                if (!p) return null;
                return p.display;
              })
        }
        IconComponent = {ExpandMore}
        onClose={selectClosed}
        MenuProps={MenuProps}
      >
        <MenuItem
          value='all'
          classes={{
            root: isAllSelected ? 'selectedAll' : '',
          }}>
          <div className={classes.checkBox}>
            <div
              className={`check-box-label  ${isAllSelected ? 'checked' : 'unchecked'} ${
                selected.length > 0 && selected.length < (valueObj && valueObj.length)
                  ? 'intermediate'
                  : ''
              }`}
            />
          </div>
          <div className={classes.listItemText}>
            {'All Locations'}
          </div>
        </MenuItem>

        {options.map(item => (
          <MenuItem
            key={item.value}
            value={item.value}
            disabled={item.disabled}
            style={{ fontSize: '20' }}
          >
            <div className={classes.checkBox}>
              <div
                className={`check-box-label  ${
                  selected.indexOf(item.value) > -1 ? 'checked' : 'unchecked'
                }`}
              />
            </div>
            <div className={classes.listItemText}>
              {item.display}
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelectWithCheckBox;